module.exports = __webpack_public_path__ + "3f46193f81d4c778090bdaa78d40dd48.svg";